
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.182 1.545a7.636 7.636 0 110 15.273 7.636 7.636 0 010-15.273zm0 7.637V6.455m0 2.727l3.409 3.41","stroke":"currentColor","stroke-width":"1.5","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    